import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { initialThreePsState } from "./threePsState";
import { ThreePsStore } from "./threePsTypes";
import { createThreePsStoreAsyncActions } from "./threePsAsyncActions";
import { createThreePsStoreActions } from "./threePsActions";

export const createThreePsCodesStore = (initialState = initialThreePsState) => 
    devtools<ThreePsStore>(
        (set, get, store) => ({
            ...initialState,
            ...createThreePsStoreActions(set, get, store),
            ...createThreePsStoreAsyncActions(set, get, store),
        }),
        { name: "threePsCodesStore" }
    );

export const useThreePsCodesStore = create<ThreePsStore>()(createThreePsCodesStore());